import { apolloClient } from '@/common/service/apolloClient'
import { productSearchQuery, estimateProductSearchQuery } from '@/search/queries'
import { getSearchProducts as GetSearchProducts } from '@/search/types'

export const getAllSearchProducts = (
  categoryIds: [],
  minUnitPrice: number,
  maxUnitPrice: number,
  quantity: number,
  printingMethod: string,
  orderMethod: string,
  facets: [],
  offset: number,
  limit: number,
  sortOrder: string,
  keyword: string,
  favorite: boolean,
  personalized: boolean
) => {
  return apolloClient.query<GetSearchProducts>({
    query: productSearchQuery,
    variables: {
      categoryIds: categoryIds,
      minUnitPrice: minUnitPrice,
      maxUnitPrice: maxUnitPrice,
      quantity: quantity,
      printingMethod: printingMethod,
      facets: facets,
      offset: offset,
      limit: limit,
      sortOrder: sortOrder,
      orderMethod: orderMethod,
      keyword: keyword,
      favorite: favorite,
      personalized: personalized
    },
    fetchPolicy: 'no-cache'
  })
}

export const estimateSearchProducts = (
  categoryIds: [],
  minUnitPrice: number,
  maxUnitPrice: number,
  quantity: number,
  printingMethod: string,
  orderMethod: string,
  facets: [],
  offset: number,
  limit: number,
  sortOrder: string
) => {
  return apolloClient.query<GetSearchProducts>({
    query: estimateProductSearchQuery,
    variables: {
      categoryIds: categoryIds,
      minUnitPrice: minUnitPrice,
      maxUnitPrice: maxUnitPrice,
      quantity: quantity,
      printingMethod: printingMethod,
      orderMethod: orderMethod,
      facets: facets,
      offset: offset,
      limit: limit,
      sortOrder: sortOrder
    },
    fetchPolicy: 'no-cache'
  })
}
